module.exports = __webpack_public_path__ + "static/media/27OCHA6.352e0258.jpg";